var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9897 3.0582H18.6954V0.976379H12.0216L9.80375 9.15476H9.74308L7.54539 0.976379H0.851562V3.05814H1.53709C1.69557 3.08394 1.84261 3.15687 1.95904 3.26743C2.07547 3.378 2.1559 3.52107 2.18985 3.678V12.4485C2.1538 12.5998 2.07162 12.7362 1.95468 12.8387C1.83774 12.9413 1.69181 13.005 1.53709 13.0209H0.851562V15.1028H6.20471V13.0209H4.86642V3.80167H4.9445L8.02933 15.1028H10.4489L13.5741 3.80167H13.6397V13.0209H12.3014V15.1028H18.6954V13.0209H17.9897C17.8385 13.0013 17.6969 12.9359 17.5839 12.8336C17.4709 12.7313 17.3917 12.597 17.3571 12.4485V3.67806C17.3899 3.52397 17.4674 3.38297 17.5799 3.27272C17.6924 3.16246 17.835 3.08784 17.9897 3.0582V3.0582Z",
    fill: ""
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.478395b4.svg";
export { ForwardRef as ReactComponent };